import * as React from "react";
import { DietPrescriptionItemRequest } from "@curefit/gmf-common";
import {default as AppUtils, EpochConstants, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import IEditedBy from "../../models/IEditedBy";
import {PatientDietPlanEditorProps} from "../../components/patient/edit/PatientDietPlanEditor";
import IFoodCategory from "../../models/IFoodCategory";
import IMealItem from "../../models/IMealItem";
import IFetchMealsByCaloriesRequest from "../../models/IFetchMealsByCaloriesRequest";
import IDietPrescriptionWrapper from "../../models/patients/IDietPrescriptionWrapper";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";
import IMealSlot from "../../models/IMealSlot";
import {AppConstants} from "../../utils/AppConstants";
import {PatientDietPlanViewProps} from "../../components/patient/view/PatientDietPlanView";
import IFoodGroup from "../../../../common/models/IFoodGroup";
import {IDietGuideline, IDietMeal, IDietPlan} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 16/04/18.
 */

export interface DietPlanEditViewContProps {
    editedBy: IEditedBy,
    patientId: number,
    secondaryPatientId: string,
    patientDietPlan: IDietPlan,
    staticMealSlots: string[],
    staticMealPreferences: string[],
    displayMode?: EditViewDisplayMode,
    fetchPatientDietPlan?: (patientId: number) => any,
    fetchStaticMealData?: (input: string) => Promise<any>,
    savePatientDietPlan?: (patientId: number, patientDietPlan: IDietPrescriptionWrapper) => any,
    staticFoodGroups: IFoodCategory[],
    fetchStaticFoodGroups: () => Promise<IFoodCategory[]>;
    fetchMealsByCalorie: (calorieBreakup: IFetchMealsByCaloriesRequest) => Promise<IMealItem[]>;
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse[]>;
    fetchMealByMealId: (mealId: string) => Promise<IMealItem>;
    previewMeal: (meal: IMealItem) => Promise<IMealItem>;
    createMeal: (meal: IMealItem) => Promise<IMealItem>;
    fetchStaticDietGuidelines: (input: string, category: string) => Promise<any[]>;
    isSelf: boolean;
    consultationId: number;
    suggestions: {[key: string]: any}
}

export interface DietPlanEditViewContState {
    updatedDietPlan: {item: IDietPlan},
    isPatientDietPlanLoaded: LOADING_STATE
}

class DietPlanEditViewCont extends React.Component<DietPlanEditViewContProps, DietPlanEditViewContState> {

    constructor(props: DietPlanEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: DietPlanEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedDietPlanFromProps = (props: DietPlanEditViewContProps): {item: DietPrescriptionItemRequest} => {
        let currUpdatedConcerns: {item: DietPrescriptionItemRequest} = { item: ModelFactory.createNewDietPlanPrescriptionItem() };
        currUpdatedConcerns.item = props.patientDietPlan;
        return currUpdatedConcerns;
    }

    getStateFromProps = (props: DietPlanEditViewContProps) => {
        let currState: DietPlanEditViewContState = {
            updatedDietPlan: {item: props.patientDietPlan},
            isPatientDietPlanLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( _.isNull(props.patientDietPlan) ) {
            props.fetchPatientDietPlan(this.props.patientId);
            currState.isPatientDietPlanLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedDietPlan = { item: props.patientDietPlan };
            currState.isPatientDietPlanLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getDietPlanEditViewTemplateProps = () => {
        let patientDietPlanViewProps: PatientDietPlanViewProps = {
            patientDietPlan: this.props.patientDietPlan
        };
        let patientDietPlanEditorProps: PatientDietPlanEditorProps = {
            updatedDietPlan: this.state.updatedDietPlan,
            updateDietPlan: this.updateDietPlan,
            fetchStaticMealData: this.props.fetchStaticMealData,
            staticFoodGroups: this.props.staticFoodGroups,
            fetchStaticFoodGroups: this.props.fetchStaticFoodGroups,
            fetchMealsByCalories: this.props.fetchMealsByCalorie,
            fetchDishByDishName: this.props.fetchDishByDishName,
            fetchMealByMealId: this.props.fetchMealByMealId,
            previewMeal: this.props.previewMeal,
            createMeal: this.props.createMeal,
            fetchStaticDietGuidelines: this.props.fetchStaticDietGuidelines,
            suggestions: this.props.suggestions
        }
        return {"view": patientDietPlanViewProps, "edit": patientDietPlanEditorProps};
    }

    updateDietPlan = (updatedDietPlan: {item: IDietPlan}) => {
        this.setState({updatedDietPlan});
    }

    savePatientDietPlan = () => {
        let myInstance = this;
        let saveDietPlan: IDietPrescriptionWrapper = this.getSaveObject();
        if (!_.isEmpty(saveDietPlan)) {
            this.setState({isPatientDietPlanLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientDietPlan(this.props.patientId, saveDietPlan).then(function(){
                myInstance.setState({isPatientDietPlanLoaded: LOADING_STATE.LOADED})
            });
        }
    }

    cancelActionHandler = () => {
        this.setState({updatedDietPlan: this.getUpdatedDietPlanFromProps(this.props)});
    }

    isDietPlanDirty = () => {
        let isDirty = false;
        let dietPrescriptionItem = this.state.updatedDietPlan.item;
        if (!_.isEmpty(dietPrescriptionItem.meals)) {
            _.map(dietPrescriptionItem.meals, (meal: IMealSlot) => {
                if (!_.isEmpty(meal.details) && _.isEmpty(meal.details.mealIds)) {
                    isDirty = true;
                    return false;
                } else if (!_.isEmpty(meal.details) && _.isEmpty(meal.details.calorieBreakup)) {
                    isDirty = true;
                    return false;
                } else if (!_.isEmpty(meal.details) && !_.isEmpty(meal.details.calorieBreakup)) {
                    meal.details.calorieBreakup.map((foodGroups: any) => {
                        foodGroups.map((foodGroup: IFoodGroup) => {
                            if (_.isEmpty(foodGroup.foodgroups[0]) || !AppUtils.isDefined(foodGroup.contribution) || foodGroup.contribution === "" as any) {
                                isDirty = true;
                                return false;
                            }
                        })
                    })
                }
            })
        } else {
            isDirty = true;
        }
        return isDirty;
    }

    dirtyFormText = () => {
        let dirtyFormText = "";
        let dietPrescriptionItem = this.state.updatedDietPlan.item;
        if (!_.isEmpty(dietPrescriptionItem.meals)) {
            _.map(dietPrescriptionItem.meals, (meal: IMealSlot) => {
                if (!_.isEmpty(meal.details) && _.isEmpty(meal.details.mealIds)) {
                    dirtyFormText = `No meals added for ${meal.mealSlot}`;
                    return false;
                } else if (!_.isEmpty(meal.details) && _.isEmpty(meal.details.calorieBreakup)) {
                    dirtyFormText = `No themes added for ${meal.mealSlot}`;
                    return false;
                } else if (!_.isEmpty(meal.details) && !_.isEmpty(meal.details.calorieBreakup)) {
                    meal.details.calorieBreakup.map((foodGroups: any) => {
                        foodGroups.map((foodGroup: IFoodGroup) => {
                            if (!AppUtils.isDefined(foodGroup.contribution) || foodGroup.contribution === "" as any) {
                                dirtyFormText = `Unrecognised contribution for ${foodGroup.foodgroups[0]} in ${meal.mealSlot}`;
                                return false;
                            } else if (_.isEmpty(foodGroup.foodgroups[0])) {
                                dirtyFormText = `Empty food group in ${meal.mealSlot}`;
                                return false;
                            }
                        })
                    })
                }
            })
        } else {
            dirtyFormText = "No meals added for Diet Plan."
        }
        return dirtyFormText;
    }

    getSaveObject = (): IDietPlan => {
        let saveDietPlan: IDietPlan = {
            guidelines: [],
            meals: [],
            referenceId: this.props.consultationId.toString(),
            themes: []
        };
        if (!_.isEmpty(this.state.updatedDietPlan) && !_.isEmpty(this.state.updatedDietPlan.item)) {
            if (!_.isEmpty(this.state.updatedDietPlan.item.themes)) {
                saveDietPlan.themes = this.state.updatedDietPlan.item.themes;
            }
            if (!_.isEmpty(this.state.updatedDietPlan.item.guidelines)) {
                saveDietPlan.guidelines = this.state.updatedDietPlan.item.guidelines;
            }
            if (!_.isEmpty(this.state.updatedDietPlan.item.meals)) {
                saveDietPlan.meals = this.state.updatedDietPlan.item.meals;
            }
        }
        return saveDietPlan;
    }

    render() {
        let isDietPlanDataLoaded =  this.state.isPatientDietPlanLoaded === LOADING_STATE.LOADED;
        return (
            <div className="dietPlan-editview-cont">
                {
                    isDietPlanDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Diet Plan"} templateName={"dietPlan"}
                                  templateProps={this.getDietPlanEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientDietPlan}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isDietPlanDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default DietPlanEditViewCont;